<div class="custom-mat-dialog-form">
    <button mat-icon-button class="cross-button" [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>

    <div style="justify-content: space-between; display: flex;">
        <div class="popup-header">
            <h3>{{title}}</h3>
        </div>

        <div class="space-left" style="margin-right:15px">
            <mat-form-field class="search-input max-30w" style="width: 25vw;">
                <input placeholder="Filter"
                    matInput
                    (keyup)="applyFilter($event)">
            </mat-form-field>
        </div>
    </div> 

    <div class="popup-table-container">
        <table mat-table
           [dataSource]="dataSource"
           multiTemplateDataRows
           matSort
           class="mat-elevation-z8 mat-table-custom" id="logshistorypopuplist">

        <ng-container matColumnDef="Identifier">
            <th mat-header-cell *matHeaderCellDef> Identifier </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.Identifier"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="FieldName">
            <th mat-header-cell *matHeaderCellDef> Field Name </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.FieldName"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="OldValue">
            <th mat-header-cell *matHeaderCellDef> Old Value </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.OldValue"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="NewValue">
            <th mat-header-cell *matHeaderCellDef> New Value </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.NewValue"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="Scope">
            <th mat-header-cell *matHeaderCellDef> Scope </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.Scope"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="TenantId">
            <th mat-header-cell *matHeaderCellDef> Tenant Id </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.TenantId"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="ControllerTypeId">
            <th mat-header-cell *matHeaderCellDef> Controller Type Id </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.ControllerTypeId"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="ChangedBy">
            <th mat-header-cell *matHeaderCellDef> Changed By </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.ChangedBy"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="CreatedAtUtc">
            <th mat-header-cell *matHeaderCellDef> Created At </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.CreatedAtUtc | date:'yyyy-MM-dd HH:mm'"></p>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="opmode-item"></tr>

        </table>
    </div>
</div>
